import React from 'react';

// ✅ Role-based access control
// Usage: <RoleGuard role={userRole} allow={['staff','owner']} />

// Role permissions
const PERMISSIONS = {
  owner: {
    canView:   true,
    canCreate: true,
    canEdit:   true,
    canDelete: true,
    canBill:   true,
    canReport: true,
    canStaff:  true,
    canSettings: true,
  },
  staff: {
    canView:   true,
    canCreate: true,
    canEdit:   true,
    canDelete: true,
    canBill:   true,
    canReport: true,
    canStaff:  false,
    canSettings: false,
  },
  cashier: {
    canView:   true,   // Can view items (for billing)
    canCreate: false,  // Cannot add items
    canEdit:   false,  // Cannot edit items
    canDelete: false,  // Cannot delete
    canBill:   true,   // CAN create bills!
    canReport: false,  // Cannot see reports
    canStaff:  false,
    canSettings: false,
  },
  viewer: {
    canView:   true,   // Can view everything
    canCreate: false,  // Cannot create
    canEdit:   false,  // Cannot edit
    canDelete: false,  // Cannot delete
    canBill:   false,  // Cannot bill
    canReport: true,   // Can see reports
    canStaff:  false,
    canSettings: false,
  },
};

// ✅ Hook to check permissions
export function usePermissions(role) {
  const r = role || 'owner';
  return PERMISSIONS[r] || PERMISSIONS.owner;
}

// ✅ Guard component — blocks access
export function RoleGuard({ role, permission, children, fallback }) {
  const perms = usePermissions(role);

  if (!perms[permission]) {
    return fallback || (
      <div style={S.blocked}>
        <div style={{fontSize:'48px',marginBottom:'12px'}}>🚫</div>
        <h3 style={{color:'#E74C3C',margin:'0 0 8px'}}>
          Access Denied!
        </h3>
        <p style={{color:'#666',fontSize:'14px'}}>
          உங்கள் role ({role})-க்கு
          இந்த feature access இல்லை!
        </p>
        <p style={{color:'#888',fontSize:'12px',marginTop:'8px'}}>
          Owner-கிட்ட கேளுங்கள்!
        </p>
      </div>
    );
  }

  return children;
}

// ✅ Simple check function
export function hasPermission(role, permission) {
  const perms = PERMISSIONS[role] || PERMISSIONS.owner;
  return perms[permission] || false;
}

// ✅ Role badge component
export function RoleBadge({ role }) {
  const config = {
    owner:   { label:'👑 Owner',   bg:'#FFF9E6', color:'#C9A84C' },
    staff:   { label:'👤 Staff',   bg:'#E8F8F0', color:'#27AE60' },
    cashier: { label:'💰 Cashier', bg:'#EBF5FB', color:'#3498DB' },
    viewer:  { label:'👁️ Viewer',  bg:'#F3E5F5', color:'#9B59B6' },
  }[role] || { label:'👤 User', bg:'#F0F0F0', color:'#888' };

  return (
    <span style={{
      padding:'3px 10px', borderRadius:'12px',
      fontSize:'12px', fontWeight:'700',
      background: config.bg, color: config.color,
    }}>
      {config.label}
    </span>
  );
}

const S = {
  blocked: {
    textAlign:'center',padding:'60px 20px',
    maxWidth:'400px',margin:'40px auto',
    background:'white',borderRadius:'16px',
    boxShadow:'0 4px 20px rgba(0,0,0,0.08)',
  },
};

export default { RoleGuard, RoleBadge, usePermissions, hasPermission };

